export default {
  apartments: {
    breadcrumbHome: 'Startseite',
    breadcrumbSolutions: 'Lösungen',
    breadcrumbCurrent: 'Mehrfamilienhäuser & Immobilien',
    hero: {
      eyebrow: 'Mehrfamilienhäuser & Immobilien',
      title: 'Sicherheit für ganze Wohngebäude',
      lead: 'Hauseingang, Treppenhaus, Tiefgarage – wir planen Überwachung für Mehrfamilienhäuser, die Mieter schützt und Eigentümern Ruhe gibt.',
    },
    areas: {
      title: 'Überwachungspunkte im Mehrfamilienhaus',
      lead: 'Gemeinschaftsflächen sind die wichtigsten Ansatzpunkte. Wir beachten dabei immer die Rechte aller Bewohner.',
      items: {
        '0': { title: 'Hauseingang', desc: 'Der Hauseingang ist die Visitenkarte des Gebäudes – und der wichtigste Überwachungspunkt. Kameras erfassen, wer das Haus betritt.' },
        '1': { title: 'Treppenhaus', desc: 'Treppenhäuser sind Übergänge mit vielen Bewegungen. Kompakte Kameras schließen die Lücken zwischen Etagen unauffällig.' },
        '2': { title: 'Fahrradkeller', desc: 'Fahrräder und E-Bikes sind beliebte Diebstahlziele. Überwachung im Keller schreckt ab und hilft bei der Aufklärung.' },
        '3': { title: 'Außenanlage', desc: 'Spielplätze, Grünflächen und Wege gehören zum Gemeinschaftsbereich. Wetterfeste Kameras schützen auch hier.' },
        '4': { title: 'Tiefgarage', desc: 'Parkplätze in der Tiefgarage sind nachts besonders gefährdet. Gut beleuchtete Überwachung schafft Sicherheit.' },
        '5': { title: 'Briefkastenanlage', desc: 'Briefkästen und Paketfächer sind Dreh- und Angelpunkt für Paketdiebstahl. Kameras am Zugang helfen spürbar.' },
      },
    },
    protection: {
      eyebrow: 'Datenschutz & Hausordnung',
      title: 'Überwachen, ohne zu verletzen',
      lead: 'Im Mehrfamilienhaus treffen viele Interessen aufeinander. Wir setzen Überwachung so um, dass sie die Privatsphäre der Bewohner respektiert – und rechtlich sauber ist.',
      items: {
        '0': { title: 'Privatzonen-Maskierung', desc: 'Fenster, Wohnungstüren und Privatbereiche werden technisch ausgeblendet – nur die Gemeinschaftsflächen bleiben im Bild.' },
        '1': { title: 'Beschluss & Hausordnung', desc: 'Videoüberwachung im Mehrfamilienhaus braucht eine tragfähige Grundlage. Wir unterstützen Sie bei der sauberen Umsetzung.' },
        '2': { title: 'Hinweisschilder', desc: 'Klare Hinweise am Eingang informieren Mieter und Besucher – transparent, fair und rechtlich empfohlen.' },
      },
    },
    value: {
      eyebrow: 'Mehrwert',
      title: 'Vorteile für Eigentümer und Verwalter',
      lead: 'Eine durchdachte Anlage zahlt sich für alle aus: Mieter fühlen sich sicherer, Eigentümer schützen ihre Substanz und Verwalter bekommen Klarheit bei Vorfällen.',
      list: {
        '0': 'Zugriff für Verwalter und Eigentümer mit getrennten Benutzerrechten',
        '1': 'Aufzeichnung der letzten Tage bis Wochen – je nach Speicherkonfiguration',
        '2': 'Entlastung der Hausverwaltung bei Vorfällen und Streitfällen',
        '3': 'Lückenlose Dokumentation bei Vandalismus oder Einbruch',
        '4': 'Abschreckung für unberechtigte Fremdzugänge',
        '5': 'Mehr Sicherheitsgefühl für Mieter und Eigentümer',
      },
      note: 'Hinweis: Die rechtliche Zulässigkeit der Videoüberwachung in Wohngebäuden hängt stark vom Einzelfall ab. Wir beraten Sie, ersetzen aber keine Rechtsberatung.',
    },
    cta: {
      title: 'Mehr Sicherheit für Ihr Haus',
      lead: 'Wir beraten Eigentümergemeinschaften und Verwalter unverbindlich – von der ersten Idee bis zur schlüsselfertigen Anlage.',
      primary: 'Beratungstermin vereinbaren',
      secondary: 'KameraPlaner starten',
    },
  },
};